import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import shadiPhoto from './assets/shadi.png';
import iyadPhoto from './assets/iyad.png';

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    setIsLoaded(true);
  }, []);

  return (
    <div className={`app ${isLoaded ? 'loaded' : ''}`}>
      {/* Subtle Background */}
      <div className="background">
        <div className="gradient-wash"></div>
        <div className="vignette"></div>
      </div>

      {/* Main Content */}
      <main className="main-content">
        {/* Hero Section */}
        <header className="hero">
          <div className="hero-ornament top"></div>
          
          <div className="logo-mark">
            <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M40 8L72 68H8L40 8Z" stroke="url(#gold-gradient)" strokeWidth="1" fill="none"/>
              <path d="M40 24L60 60H20L40 24Z" stroke="url(#gold-gradient)" strokeWidth="0.5" fill="none" opacity="0.5"/>
              <defs>
                <linearGradient id="gold-gradient" x1="0%" y1="100%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#a08642" />
                  <stop offset="50%" stopColor="#d4bc7a" />
                  <stop offset="100%" stopColor="#a08642" />
                </linearGradient>
              </defs>
            </svg>
          </div>

          <h1 className="logo-text">
            <span className="logo-gradient">Gradient</span>
            <span className="logo-separator"></span>
            <span className="logo-hill">Hill</span>
          </h1>
          
          <div className="tagline-container">
            <span className="tagline-line"></span>
            <p className="tagline">Investment Management</p>
            <span className="tagline-line"></span>
          </div>

          <div className="hero-ornament bottom"></div>
        </header>

        {/* Philosophy Section */}
        <section className="philosophy">
          <blockquote className="philosophy-quote">
            <span className="quote-mark">"</span>
            At the intersection of artificial intelligence and disciplined 
            capital allocation, we find unprecedented opportunities for 
            enduring value creation.
            <span className="quote-mark closing">"</span>
          </blockquote>
        </section>

        {/* Divider */}
        <div className="section-divider">
          <span className="divider-diamond">◇</span>
        </div>

        {/* Founders Section */}
        <section className="founders">
          <h2 className="section-title">Founding Partners</h2>
          
          <div className="founders-container">
            {/* Shadi Copty */}
            <article className="founder">
              <div className="founder-portrait">
                <div className="portrait-frame">
                  <img src={shadiPhoto} alt="Shadi Copty" className="portrait-image" />
                </div>
              </div>
              <div className="founder-details">
                <h3 className="founder-name">Shadi Copty</h3>
                <p className="founder-role">Co-Founder</p>
                <p className="founder-expertise">Artificial Intelligence</p>
                <div className="founder-description">
                  <p>
                    A pioneering force in Generative AI with deep technical expertise, 
                    bringing visionary insights to identify transformative opportunities 
                    at the frontier of artificial intelligence.
                  </p>
                </div>
              </div>
            </article>

            {/* Elegant Separator */}
            <div className="founders-separator">
              <span className="separator-line"></span>
              <span className="separator-ampersand">&</span>
              <span className="separator-line"></span>
            </div>

            {/* Iyad Farah */}
            <article className="founder">
              <div className="founder-portrait">
                <div className="portrait-frame">
                  <img src={iyadPhoto} alt="Iyad Farah" className="portrait-image" />
                </div>
              </div>
              <div className="founder-details">
                <h3 className="founder-name">Iyad Farah</h3>
                <p className="founder-role">Co-Founder</p>
                <p className="founder-expertise">Capital Management</p>
                <div className="founder-description">
                  <p>
                    A distinguished investment professional with decades of experience 
                    in capital markets, portfolio optimization, and risk management 
                    across premier global financial institutions.
                  </p>
                </div>
              </div>
            </article>
          </div>
        </section>

        {/* Divider */}
        <div className="section-divider">
          <span className="divider-diamond">◇</span>
        </div>

        {/* Investors Link */}
        <section className="investors-link">
          <Link to="/investors" className="investors-button">
            For Investors
          </Link>
        </section>

        {/* Contact Section */}
        <section className="contact">
          <p className="contact-label">Inquiries</p>
          <a href="mailto:contact@gradienthill.com" className="contact-email">
            contact@gradienthill.com
          </a>
        </section>

        {/* Footer */}
        <footer className="footer">
          <div className="footer-ornament"></div>
          <p className="copyright">© 2025 Gradient Hill</p>
        </footer>
      </main>
    </div>
  );
}

export default App;
